import Card from "../../../../../FTTX/component/Card";
import Button from "../../../../../FTTX/component/Button";
import { BTN_TYPE } from "../../../../../FTTX/GlobalConstant";

import styles from "./HbbPlanList.module.scss"
const HbbPlanList = ({ bundleList, handleSelectedPlan, translations }) => {
  return <div className={styles["bundle-list-wrapper"]}>
    {
      bundleList.map((bundle) => <Card className='bundle-plan-card'>
        <div className={styles.description}>
          {bundle.description}
        </div>
        <div className={styles["validity-wrapper"]}>
          <div>
            <span className={styles["bold-text"]}>{translations?.speed}: </span>
            <span>{bundle?.data} {bundle?.dataUnit ?? '-'}</span>
          </div>
          <div>
            <span className={styles["bold-text"]}>{translations?.validity}: </span>
            <span>{bundle.validity} {bundle.validityUnit}</span>
          </div>
        </div>
        <div className={styles["footer-wrapper"]}>
          <div className={styles["bundle-amount-wrapper"]}>
            <span>{`${bundle.currency} ${bundle.amount}`}</span>
          </div>
          <div>
            <Button text={translations?.select} btnType={BTN_TYPE.DANGER} callBack={() => handleSelectedPlan(bundle)} />
          </div>
        </div>
      </Card>)
    }
  </div>
}

export default HbbPlanList